import { TimeSlot } from "@src/appV2/redesign/Shift/Open/types";

import { useIsWorkplaceReviewUXUpdateEnabled } from "../../../../PostShiftReview/hooks/useIsWorkplaceReviewUXUpdateEnabled";
import { shiftPeriodToTimeSlot } from "../../../../Shifts/Shift/types";
import {
  ReviewTag,
  toShiftPeriod,
  WorkplaceCommentAttributesType,
} from "../api/useWorkplaceComments";

export function useGetReviewTag(params: {
  shiftPeriod?: WorkplaceCommentAttributesType["shiftPeriod"];
  reviewTag?: WorkplaceCommentAttributesType["reviewTag"];
}): ReviewTag | TimeSlot | undefined {
  const { shiftPeriod, reviewTag } = params;
  const { isEnabled: isWorkplaceReviewUXUpdateEnabled } = useIsWorkplaceReviewUXUpdateEnabled();

  const timeSlot = shiftPeriod ? shiftPeriodToTimeSlot[toShiftPeriod(shiftPeriod)] : undefined;

  if (!isWorkplaceReviewUXUpdateEnabled || !reviewTag || reviewTag === ReviewTag.FLEX) {
    return timeSlot;
  }

  if (reviewTag === ReviewTag.SELF_REPORTED) {
    return undefined;
  }

  return reviewTag;
}
